import { Person } from "./Person";

export class Relationship {
  public role: string = "";
  public subRole: string = "";
  public person: Person = new Person(0);

  public constructor(public id: number) {}
}
